"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateGiftCardNumberErrorCode = exports.GiftCardProviderType = exports.CardTransactionType = exports.GiftCardNumberType = void 0;
var GiftCardNumberType;
(function (GiftCardNumberType) {
    GiftCardNumberType[GiftCardNumberType["Physical"] = 1] = "Physical";
    GiftCardNumberType[GiftCardNumberType["AutoGenerated"] = 2] = "AutoGenerated";
    GiftCardNumberType[GiftCardNumberType["Manual"] = 3] = "Manual";
})(GiftCardNumberType = exports.GiftCardNumberType || (exports.GiftCardNumberType = {}));
var CardTransactionType;
(function (CardTransactionType) {
    CardTransactionType[CardTransactionType["Unknown"] = -1] = "Unknown";
    CardTransactionType[CardTransactionType["Purchased"] = 0] = "Purchased";
    CardTransactionType[CardTransactionType["Used"] = 1] = "Used";
    CardTransactionType[CardTransactionType["Refunded"] = 2] = "Refunded";
    CardTransactionType[CardTransactionType["Renewed"] = 3] = "Renewed";
    CardTransactionType[CardTransactionType["Failed"] = 4] = "Failed";
    CardTransactionType[CardTransactionType["Import"] = 5] = "Import";
    CardTransactionType[CardTransactionType["Revenue"] = 6] = "Revenue";
})(CardTransactionType = exports.CardTransactionType || (exports.CardTransactionType = {}));
var GiftCardProviderType;
(function (GiftCardProviderType) {
    GiftCardProviderType[GiftCardProviderType["Ancon"] = 0] = "Ancon";
    GiftCardProviderType[GiftCardProviderType["Retain24"] = 1] = "Retain24";
    GiftCardProviderType[GiftCardProviderType["MPSGiftCards"] = 2] = "MPSGiftCards";
})(GiftCardProviderType = exports.GiftCardProviderType || (exports.GiftCardProviderType = {}));
var ValidateGiftCardNumberErrorCode;
(function (ValidateGiftCardNumberErrorCode) {
    ValidateGiftCardNumberErrorCode["ExistingNumber"] = "EXISTING_NUMBER";
    ValidateGiftCardNumberErrorCode["InvalidNumber"] = "INVALID_NUMBER";
    ValidateGiftCardNumberErrorCode["InactiveCard"] = "INACTIVE_CARD";
    // Retain24
    ValidateGiftCardNumberErrorCode["TemplateNotAssociated"] = "TEMPLATE_NOT_ASSOCIATED";
    ValidateGiftCardNumberErrorCode["OutOfSalesDateRange"] = "OUT_OF_SALES_DATE_RANGE";
    ValidateGiftCardNumberErrorCode["InactiveOrInvalidCard"] = "INACTIVE_OR_INVALID_CARD";
})(ValidateGiftCardNumberErrorCode = exports.ValidateGiftCardNumberErrorCode || (exports.ValidateGiftCardNumberErrorCode = {}));
